import React, { useState, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import DownloadButton from '../dataOutput/DownloadButton';
import FilterComponent from '../dataOutput/FilterComponent';
import '../../style.css'

const paginationComponentOptions = {
    noRowsPerPage: false,
    rowsPerPageText: 'Row per page',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'All',
};

function BlupsMeansDataTable({data, runBlups}) {
    const columns = useMemo(() => {
        const preTraitCols = ['FACTOR1', 'NAME', 'PEDIGREE', 'EXPT', 'LOC'];
        const postTraitCols = ['YEAR'];
        const dataCols = Object.keys(data[0]);
        const traitCols = dataCols.filter(col => !preTraitCols.includes(col) && !postTraitCols.includes(col));
        return [...preTraitCols, ...traitCols, ...postTraitCols];
    }, [data]);

    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const filteredItems = data.filter(item => {
        if (filterText === '') {
            return true;
        }
        else if (!item.NAME) {
            return false;
        }
        else {
            return item.NAME.toLowerCase().includes(filterText.toLowerCase())
        }
    });

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };
        return (
            <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
        );
    }, [filterText, resetPaginationToggle]);

    return (
        <div>
            <DataTable stickyHeader={true}
                columns={columns.map(column => ({
                    name: column,
                    selector: row => row[column],
                    sortable: true,
                    wrap: true
                }))}
                data={filteredItems}
                pagination
                paginationPerPage={6}
                paginationRowsPerPageOptions={[6, 10, 15, 20]}
                paginationComponentOptions={paginationComponentOptions}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
            />
            <DownloadButton data={filteredItems} columns={columns} />
            <button style={{ marginLeft: "5px", marginBottom: "5px" }} className="btn btn-success" onClick={runBlups}>
                Run BLUPs
            </button>
        </div>

    );
};

export default BlupsMeansDataTable;